import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
// import OneSignal from "react-onesignal";

import request from "../../utils/request";
import requestAI from "../../utils/request-ai";
import { updateCompanyManually } from "./companySlice";

const authAdapter = createEntityAdapter({
  selectId: (member) => member.id,
});

const initialState = authAdapter.getInitialState({
  isLoading: false,
  error: null,
  user: null,
  isSideNavOpened: true,
  linkedinPages: null,
  actionButtonToggle: false,
  linkedinExpired: false,
  team_members: [],
});

// // Initial state
// const initialState = {
//   isLoading: false,
//   error: null,
//   user: null,
//   isSideNavOpened: true,
//   linkedinPages: null,
//   actionButtonToggle: false,
//   linkedinExpired: false,
//   team_members: [],
// };

// LOGIN
export const login = createAsyncThunk(
  "recruiter/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/login`,
        method: "POST",
        data: { email, password },
      });

      window.localStorage.setItem("@getGeek/token", response?.data?.token);

      // const userOneSignalId = OneSignal.User.PushSubscription.id;

      // UPDATE USER FCM TOKEN FOR NOTIFICATION
      // if (userOneSignalId) {
      //   const updateResponse = await request({
      //     url: "/recruiter/update-user",
      //     method: "PUT",
      //     data: {
      //       FCMToken: userOneSignalId,
      //       userId: response?.data?.user?._id,
      //     },
      //   });

      //   return updateResponse.data;
      // }

      return response.data?.user;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Google Login
export const googleLogin = createAsyncThunk(
  "recruiter/google-login",
  async ({ authCode, cb }, { rejectWithValue }) => {
    try {
      const googleAPIResponse = await axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${authCode}`,
          {
            headers: {
              Authorization: `Bearer ${authCode}`,
              Accept: "application/json",
            },
          }
        )
        .catch((err) => console.log(err));

      console.log("googleAPIResponse", googleAPIResponse);

      const response = await request({
        url: `/recruiter/google-login`,
        method: "POST",
        data: {
          email: googleAPIResponse?.data?.email,
          first_name: googleAPIResponse?.data?.given_name,
          last_name: googleAPIResponse?.data?.family_name,
          avatar: googleAPIResponse?.data?.picture || "",
        },
      });

      if (response?.data?.token && response?.data?.user?.profile_completed) {
        window.localStorage.setItem("@getGeek/token", response?.data?.token);
      } else {
        if (typeof cb === "function") cb(response?.data);
        return null;
      }

      return response.data?.user;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Register (call when user comes from signup email and sets password)
export const register = createAsyncThunk(
  "recruiter/register",
  async ({ token, password, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/register`,
        method: "POST",
        data: { token, password },
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      if (typeof cb === "function") {
        cb(response?.data);
      }

      return response;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// SEND EMAIL
export const sendEmail = createAsyncThunk(
  "recruiter/sendEmail",
  async ({ email, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/signup-email`,
        method: "POST",
        data: { email },
      });

      if (response?.message && response?.statusCode === 200) {
        enqueueSnackbar(response?.message, { variant: "success" });
        if (typeof cb === "function") {
          cb(response);
        }
      }

      return response.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// SET PASSWORD
export const resetPassword = createAsyncThunk(
  "recruiter/resetPassword",
  async ({ password, token, userId, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/save-password`,
        method: "PUT",
        data: { password, token, userId },
      });

      if (response?.message && response?.statusCode === 200) {
        enqueueSnackbar(response?.message, { variant: "success" });

        if (typeof cb === "function") {
          cb(response?.data);
        }
      }

      return response.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// FORGOT PASSWORD EMAIL SEND
export const forgotPasswordEmailSend = createAsyncThunk(
  "recruiter/forgotPasswordEmailSend",
  async ({ email, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/forget-password`,
        method: "POST",
        data: { email },
      });

      if (response?.statusCode === 200 && typeof cb === "function") {
        enqueueSnackbar(response?.message, { variant: "success" });

        cb();
      }

      return response.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// CREATE USER PROFILE
export const createUserProfile = createAsyncThunk(
  "recruiter/createUserProfile",
  async (data, { rejectWithValue }) => {
    try {
      console.log("DA", data);
      const response = await request({
        url: `/recruiter/create-profile`,
        method: "PUT",
        data,
      });

      window.localStorage.setItem("@getGeek/token", response?.data?.token);

      return response.data?.user;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// UPDATE USER PROFILE
export const updateUser = createAsyncThunk(
  "recruiter/updateUser",
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/update`,
        method: "PUT",
        data,
      });

      // enqueueSnackbar(response?.message, { variant: "success" });

      const { company } = getState();
      const companyInfo = company.company;

      console.log("companyInfo", companyInfo);

      if (response?.message && response?.statusCode === 200) {
        dispatch(
          updateCompanyManually({
            company_name: response?.data?.personal_information?.company_name,
          })
        );
      }

      return response.data;
    } catch (error) {
      console.log("error in update user", error);
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// CONNECT LINKEDIN
export const connectLinkedin = createAsyncThunk(
  "recruiter/connectLinkedin",
  async ({ code, cb }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const userId = auth.user?.id;

      const response = await request({
        url: `/recruiter/connect-linkedin`,
        method: "PUT",
        data: {
          code,
          userId,
        },
      });

      // enqueueSnackbar(response?.message, { variant: "success" });

      if (response?.statusCode === 200 && typeof cb === "function") {
        cb(response?.data);
      }

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// REFRESH LINKEDIN TOKEN
export const refreshLinkedInToken = createAsyncThunk(
  "recruiter/refreshLinkedInToken",
  async ({ cb }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const userId = auth.user?.id;

      const response = await request({
        url: `/recruiter/refresh-linkedIn-token`,
        method: "PUT",
        data: {
          userId,
        },
      });

      if (response?.statusCode === 200 && typeof cb === "function") {
        cb(response?.data);
      }

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// DISCONNECT SOCIALS
export const disconnectSocial = createAsyncThunk(
  "recruiter/disconnectSocial",
  async (social, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/delete-socials?flag=${social}`,
        method: "DELETE",
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// GET LINKEDIN PAGES
export const getLinkedinPages = createAsyncThunk(
  "recruiter/getLinkedinPages",
  async (code, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const user_id = auth.user?.id;

      const response = await requestAI({
        url: `/get_all_linkedin_pages`,
        method: "POST",
        data: {
          recruiter_id: user_id,
        },
      });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// UPDATE SOCIALS
export const updateSocials = createAsyncThunk(
  "recruiter/updateSocials",
  async ({ social, data }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const userId = auth.user?._id;

      const response = await request({
        url: `/recruiter/updateSocials`,
        method: "POST",
        data: {
          userId,
          flag: social,
          data,
        },
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// GET ALL TEAM MEMBERS
export const getAllTeamMembers = createAsyncThunk(
  "recruiter/getAllTeamMembers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/get-all-team-members`,
        method: "POST",
        data,
      });

      // enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// INVITE TEAM MEMBERS
export const inviteMembers = createAsyncThunk(
  "recruiter/inviteMembers",
  async (data, { getState, rejectWithValue }) => {
    try {
      console.log("data in invite member", data);

      const { auth } = getState();
      const invitedByRecruiterId = auth.user?.id;
      const companyId = auth?.user?.company_id;

      const response = await request({
        url: `/recruiter/invite-member`,
        method: "POST",
        data: {
          companyId,
          invitedByRecruiterId,
          members: data,
        },
      });

      // enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// UPDATE TEAM MEMBERS
export const updateMember = createAsyncThunk(
  "recruiter/updateMember",
  async (data, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/update-member`,
        method: "PUT",
        data,
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// DELETE TEAM MEMBERS
export const deleteMember = createAsyncThunk(
  "recruiter/deleteMember",
  async (data, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/delete-member`,
        method: "DELETE",
        data,
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// CHANGE TEAM MEMBERS STATUS
export const changeMemberStatus = createAsyncThunk(
  "recruiter/changeMemberStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/recruiter/change-member-status`,
        method: "POST",
        data,
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// CHECK TEAM STATUS
export const checkUserTeamStatus = createAsyncThunk(
  "recruiter/checkUserTeamStatus",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await request({
        url: `/recruiter/check-team-status`,
        method: "POST",
        data,
      });

      return response?.data;
    } catch (error) {
      console.log("Error", error);

      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      dispatch(slice.actions.logout());

      return rejectWithValue(error?.message);
    }
  }
);

// RESEND TEAM INVITE
export const resendPendingInvite = createAsyncThunk(
  "recruiter/resendPendingInvite",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await request({
        url: `/recruiter/resent-pending-invite`,
        method: "POST",
        data,
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      console.log("Error", error);

      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });

      return rejectWithValue(error?.message);
    }
  }
);

// SEND FEEDBACK
export const sendFeedback = createAsyncThunk(
  "recruiter/sendFeedback",
  async (data, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const userId = auth.user?.id;
      const response = await request({
        url: `/customer_support/create`,
        method: "POST",
        data: { ...data, recruiter_id: userId },
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(
        Array.isArray(error?.message)
          ? error?.message?.join(", ")
          : error?.message,
        {
          autoHideDuration: 3000,
          variant: "error",
        }
      );
      return rejectWithValue(error?.message);
    }
  }
);

// Slice with extraReducers to handle state transitions
const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth: () => initialState,

    setActionButtonToggle: (state, action) => {
      state.actionButtonToggle = Boolean(action.payload);
    },

    setActionLinkedIdExpired: (state, action) => {
      state.linkedinExpired = Boolean(action.payload);
    },

    toggleSideNav: (state, action) => {
      state.isSideNavOpened = action.payload;
    },

    updateUserManually: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },

    logout: (state) => {
      state.user = null;
      window.localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.user = null;
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(googleLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.user = null;
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(sendEmail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendEmail.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.user = null;
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(resetPassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.user = null;
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(forgotPasswordEmailSend.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(forgotPasswordEmailSend.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(forgotPasswordEmailSend.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(createUserProfile.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createUserProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(createUserProfile.rejected, (state, action) => {
        state.user = null;
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(getAllTeamMembers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllTeamMembers.fulfilled, (state, action) => {
        state.isLoading = false;
        authAdapter.setAll(state, action.payload || []);
        state.team_members = action.payload;
      })
      .addCase(getAllTeamMembers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(inviteMembers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(inviteMembers.fulfilled, (state, action) => {
        console.log("action.payload", action.payload);
        state.isLoading = false;
        // In case invitedMembers is null/undefined
        const invitedMembers = action.payload?.invitedMembers || [];

        if (invitedMembers.length > 0) {
          authAdapter.upsertMany(state, invitedMembers);
        }
      })
      .addCase(inviteMembers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(updateMember.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateMember.fulfilled, (state, action) => {
        state.isLoading = false;

        authAdapter.updateOne(state, {
          id: action.payload.id,
          changes: action.payload,
        });
      })
      .addCase(updateMember.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(changeMemberStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(changeMemberStatus.fulfilled, (state, action) => {
        state.isLoading = false;

        authAdapter.updateOne(state, {
          id: action.payload.id,
          changes: action.payload,
        });
      })

      .addCase(changeMemberStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(resendPendingInvite.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(resendPendingInvite.fulfilled, (state, action) => {
        state.isLoading = false;

        authAdapter.updateOne(state, {
          id: action.payload.id,
          changes: action.payload,
        });
      })

      .addCase(resendPendingInvite.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(deleteMember.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteMember.fulfilled, (state, action) => {
        state.isLoading = false;
        authAdapter.removeOne(state, action.payload.id);
      })
      .addCase(deleteMember.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(connectLinkedin.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.user = action.payload;
      })
      .addCase(refreshLinkedInToken.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(refreshLinkedInToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload || state.user;
      })
      .addCase(refreshLinkedInToken.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateSocials.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateSocials.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload || state.user;
      })
      .addCase(updateSocials.rejected, (state, action) => {
        state.user = null;
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getLinkedinPages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.linkedinPages = action.payload;
      })
      .addCase(disconnectSocial.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(disconnectSocial.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(disconnectSocial.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(sendFeedback.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendFeedback.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(sendFeedback.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  selectAll: selectAllMembers,
  selectById: selectMemberById,
  selectIds: selectMembersIds,
} = authAdapter.getSelectors((state) => state.auth);

// Exporting the reducer and resetAuth action
export const {
  resetAuth,
  updateUserManually,
  setActionButtonToggle,
  toggleSideNav,
  logout,
  setActionLinkedIdExpired,
} = slice.actions;

export const selectLoading = (state) => state.auth.isLoading;
export const selectUser = (state) => state.auth.user;
export const selectUserCompanyId = (state) => state.auth.user?.companyId;
export const selectDashboardData = (state) => state.auth.dashboardData;
export const selectError = (state) => state.auth.error;

export default slice.reducer;
